
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/FAQ",
      function () {
        return require("private-next-pages/FAQ/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/FAQ"])
      });
    }
  